<img [src]="profileImage$" *ngIf="profileImage$ && isLoading$ == false; else isLoading">
<ng-template #isLoading>
    <ngx-skeleton-loader appearance="circle" [theme]="{
        width: '75px',
        height: '75px',
        position: 'absolute',
        left: '0',
        right: '0',
        top: '-45px',
        margin: '0 auto'
          }"></ngx-skeleton-loader>
</ng-template>

